let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eGhFc"), load("k670H"), load("aDV08")]).then(() => parcelRequire('ef32u'));